import { useEffect, useState } from 'react'

import { useTable } from '@/ui/Table'
import { useManageDisruptionsColumns } from './useManageDisruptionsColumns'
import { useAreaStore, useGetAreasRoutes } from '@/modules/Areas'
import { useGetDisruptions } from '../api/useGetDisruptions'
import { filterDisruptionsByArea } from '../helpers/filterDisruptionsByArea'
import { useDisruptionsColumns } from './useDisruptionsColumns'
import { DISRUPTIONS_COLUMNS } from '../constant'
import { RowSelectionState } from '@tanstack/react-table'
import { useDisruptionsTableFormStateStore } from '../store'
import { useAuthStore } from '@/store/auth-store'

export const useDisruptionsTable = () => {
    const { data: disruptions = [], isLoading } = useGetDisruptions()
    const columnVisibility = useManageDisruptionsColumns()
    const [rowSelection, setRowSelection] = useState<RowSelectionState>({})
    const { setSelectedRowId } = useDisruptionsTableFormStateStore()
    const { selectedAreaCode: globalFilter } = useAreaStore()
    const columns = useDisruptionsColumns()
    const { areaRoutes } = useGetAreasRoutes()
    const { role } = useAuthStore()

    const table = useTable({
        data: disruptions,
        columns,
        enableGlobalFilter: true,
        getRowId: (row) => row.id.toString(),
        onRowSelectionChange: setRowSelection,
        enableMultiRowSelection: false,
        globalFilterFn: filterDisruptionsByArea(
            globalFilter,
            areaRoutes.map((route) => route.route)
        ),
        state: {
            globalFilter,
            columnVisibility,
            rowSelection,
        },
    })

    useEffect(() => {
        // populate id of selected row to store
        if (Object.keys(rowSelection).length !== 0) {
            setSelectedRowId(Object.keys(rowSelection)[0])
        }
    }, [rowSelection])

    useEffect(() => {
        if (!isLoading && disruptions) {
            // Set initial sorting

            const status = {
                id: DISRUPTIONS_COLUMNS.Status,
                desc: false,
            }

            const start = {
                id: DISRUPTIONS_COLUMNS.Start,
                desc: true,
            }

            // If role is MileageClerk sort by start time only, otherwise sort by status first and then by start time
            const sorting = role === 'MileageClerk' ? [start] : [status, start]

            table.setSorting(sorting)
        }
    }, [isLoading, role])

    return { table, setRowSelection }
}
